import { ActionReducer, createReducer, on } from '@ngrx/store';

import { setComplianceReportHistoryStore } from '../compliance-report-data/compliance-report-data.actions';
import { setComplianceReportHistoryFilters } from '../filters/filters.actions';
// NgRx actions
import { setComplianceReportTypeOption } from 'FoldersApp/apps/compliance-report-history-app/state/compliance-report-type/compliance-report-type.actions';

// Interfaces
import { ComplianceReportTypeOptions } from 'FoldersApp/apps/compliance-report-history-app/interfaces/compliance-report-type-options.interface';

export const INITIAL_COMPLIANCE_REPORT_TYPE_FILTER_STATE: ComplianceReportTypeOptions = {
    pdf_report: true,
    comp_table: true,
    fund_chart: true,
    legacy_tearsheets: true,
    legacy_y_rating: true,
    timeseries_table: true,
    holdings_category: true,
    holdings_overlap: true,
    hypotheticals: true,
    portfolio_optimizer: true,
    stress_test: true,
    attribution_table: true,
    attribution_analysis: true,
    transition_analysis: true,
    target_rates: true,
};

export const SELECT_ALL_KEY = 'select_all';

export const complianceReportType: ActionReducer<ComplianceReportTypeOptions> = createReducer(
    INITIAL_COMPLIANCE_REPORT_TYPE_FILTER_STATE,
    on(setComplianceReportTypeOption, (state: ComplianceReportTypeOptions, action) => {
        const { value, checked } = action.reportTypeOption;

        // "Select All" sets every option to the same selected status
        if (value === SELECT_ALL_KEY) {
            const newState = { ...state };
            Object.keys(state).forEach((key) => {
                newState[key] = checked;
            });
            return newState;
        }

        return { ...state, [value]: checked };
    }),
    on(setComplianceReportHistoryFilters, (state: ComplianceReportTypeOptions, action) => {
        return { ...action.reportType };
    }),
    on(setComplianceReportHistoryStore, (state: ComplianceReportTypeOptions, action) => {
        return { ...action.reportType };
    })
);
